/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Export_CsvInputs */

const en_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const fr_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter CSV`)
};

const de_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV exportieren`)
};

const it_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta CSV`)
};

const ru_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт CSV`)
};

const es_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CSV`)
};

const zh_cn2_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出 CSV 文件`)
};

const ja_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVエクスポート`)
};

const hi_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV निर्यात करें`)
};

const pt_pt2_knp_terms_export_csv = /** @type {(inputs: Knp_Terms_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CSV`)
};

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Knp_Terms_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_export_csv = /** @type {((inputs?: Knp_Terms_Export_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Export_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_export_csv(inputs)
	if (locale === "de") return de_knp_terms_export_csv(inputs)
	if (locale === "it") return it_knp_terms_export_csv(inputs)
	if (locale === "ru") return ru_knp_terms_export_csv(inputs)
	if (locale === "es") return es_knp_terms_export_csv(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_export_csv(inputs)
	if (locale === "ja") return ja_knp_terms_export_csv(inputs)
	if (locale === "hi") return hi_knp_terms_export_csv(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_export_csv(inputs)
	return en_knp_terms_export_csv(inputs)
});